import CommonDuckScene from "@/components/common/3D/CommonDuckScene/CommonDuckScene";
import styles from "./Hero.module.scss";
import { useDeviceDetector } from "@/utils/useDeviceDetector";

export default function Hero({ messages }: any) {
  const { isMobile } = useDeviceDetector();

  return (
    <section className={styles.hero_wrapper}>
      <div className="container">
        <div className={styles.textContainer}>
          <h1 className="title-section">
            <span>{messages.first_words} </span>
            <span className="title-outline">{messages.second_words} </span>
            <span>{messages.third_words}</span>
          </h1>
          <p className="paragraph">{messages.description}</p>
        </div>
      </div>
      {isMobile && (
        <div className={styles.duckScene}>
          <CommonDuckScene />
        </div>
      )}
    </section>
  );
}
